/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&lang=jsx"
export * from "./App.vue?vue&type=script&lang=jsx"

import "./App.vue?vue&type=style&index=0&id=5712836c&lang=less"

const __exports__ = script;

export default __exports__